import * as Sentry from '@sentry/react';
let seonPromise = null;
const loadSeon = ()=>{
    if (seonPromise == null) {
        seonPromise = import('@seontechnologies/seon-javascript-sdk').then((module)=>{
            try {
                module.default.init();
            } catch (error) {
                Sentry.captureException(error, {
                    tags: {
                        source: 'seon-init'
                    }
                });
            }
            return module.default;
        });
    }
    return seonPromise;
};
export const prefetchSeon = ()=>{
    void loadSeon();
};
export const getSeonSession = ()=>loadSeon().then((seon)=>seon.getSession());
